import { render, staticRenderFns } from "./chooseBuildIndex.vue?vue&type=template&id=3af72487&scoped=true"
import script from "./chooseBuildIndex.vue?vue&type=script&lang=js"
export * from "./chooseBuildIndex.vue?vue&type=script&lang=js"
import style0 from "./chooseBuildIndex.vue?vue&type=style&index=0&id=3af72487&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af72487",
  null
  
)

export default component.exports